import {
  GetLegalOnboardingRequestsFilters,
} from "./legal-onboarding.schema";

export interface LOFRProps {
  cuitCuil?: string;
  tipoSociedad?: number[];
  estado?: number[];
}

export const getLegalOnboardingFilterRequest = (
  event: LOFRProps,
): Partial<GetLegalOnboardingRequestsFilters> => {
  const estado = Array.isArray(event?.estado)
    ? (event.estado as unknown[]).reduce<number[]>((acc, item) => {
        if (Array.isArray(item)) {
          return acc.concat(item as number[]);
        }
        if (typeof item === "string") {
          const parsed = item
            .split("|")
            .map(Number)
            .filter((n) => Number.isFinite(n));
          return acc.concat(parsed);
        }
        if (typeof item === "number") {
          acc.push(item);
        }
        return acc;
      }, [])
    : [];

  return {
    ...(event?.cuitCuil
      ? {
          cuitCuil: event.cuitCuil,
        }
      : {}),
    ...(event?.tipoSociedad?.length
      ? {
          tipoSociedad: event.tipoSociedad,
        }
      : {}),
    ...(estado?.length
      ? {
          estado,
        }
      : {}),
  };
};
